export const END_CUSTOMER = 'END_CUSTOMER';
export const VAR = 'VAR';
export const CALIX_EMPLOYEE = 'CALIX_EMPLOYEE';
